import { SchedulerDateNavigationSection } from '@lp/features/Scheduler/components';
import { WorkdaySyncData } from '@lp/features/Scheduler/types';
import { OMSSchedulerViewType } from '@lp/features/Scheduler/SchedulerOMS';
import { OMSResourcesWithShifts } from '@/api/apis/resources/schedule';
import { OMSSchedulerFiltersSection } from './components';

type OMSSchedulerControlRowProps = {
  readonly?: boolean;
  selectedDate: Date;
  shiftsData: OMSResourcesWithShifts;
  workdayData?: WorkdaySyncData;
  viewMode: OMSSchedulerViewType;
  withPersonalView?: boolean;
  onViewModeChange: (mode: OMSSchedulerViewType) => void;
  onDateChange: (date: Date) => void;
};

export const OMSSchedulerControlRow = ({
  readonly,
  selectedDate,
  shiftsData,
  workdayData,
  viewMode,
  withPersonalView,
  onViewModeChange,
  onDateChange,
}: OMSSchedulerControlRowProps) => {
  return (
    <div className="flex items-center gap-2 justify-between grow">
      <SchedulerDateNavigationSection selectedDate={selectedDate} onDateChange={onDateChange} />
      <OMSSchedulerFiltersSection
        readonly={readonly}
        shiftsData={shiftsData}
        workdayData={workdayData}
        viewMode={viewMode}
        withPersonalView={withPersonalView}
        onViewModeChange={onViewModeChange}
      />
    </div>
  );
};
